import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OSUpdatesService } from '@rocksoft/mdm-sdk-v2';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';
import { AvailableOsUpdatesResolverActions, OsUpdatesApiActions } from './available-os-updates.actions';

@Injectable()
export class AvailableOsUpdatesEffects {
  constructor(
    private readonly actions: Actions,
    private readonly osUpdatesService: OSUpdatesService
  ) {}

  AvailableOsUpdatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(AvailableOsUpdatesResolverActions.availableOsUpdatesRequested),
      mergeMap(() =>
        safeMap(
          this.osUpdatesService.getOSUpdates('2.0'),
          (availableOsUpdates) =>
            OsUpdatesApiActions.availableOsUpdatesLoaded({
              availableOsUpdates,
            }),
          (error) => OsUpdatesApiActions.availableOsUpdatesLoadedError({ error })
        )
      )
    );
  });
}
